import React from "react";

interface Props {
  text?: string;
  tokenCount?: number;
  render?: (tokenCount: string) => React.ReactElement;
}

export default function TokenCounter(props: Props) {

  const { text, tokenCount, render } = props;

  let count = 0;

  if (text || tokenCount) {
    count = tokenCount !== undefined ? tokenCount : (text ? Math.ceil(text.length / 4) : 0)
  }

  const formatted = new Intl.NumberFormat("en-US").format(count);

  if (!render) {
    return (
      <span className="font-s font-code">{formatted} tokens</span>
    )
  }

  return render(formatted);
}